
export default function NotFound() {
    return <p>Pagina non trovata...</p>
}